import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import { Auth } from 'aws-amplify';
import cdkConfig from '../config/cdk-exports';
import { FeedbackData } from './FeedbackService';
import { FeedbackResponse } from '../types/feedback';

// Initialize Lambda client
const lambdaClient = new LambdaClient({ region: cdkConfig.region });

/**
 * Submit feedback using the CDK-deployed Lambda function
 * @param data The feedback data to submit
 * @returns Promise with the response
 */
export const submitFeedback = async (data: FeedbackData): Promise<FeedbackResponse> => {
  try {
    console.log('Submitting feedback to CDK Lambda:', data);
    
    // Get current credentials
    const credentials = await Auth.currentCredentials();
    
    // Create the Lambda invoke command
    const command = new InvokeCommand({
      FunctionName: cdkConfig.lambda.processFeedbackFunction.name,
      Payload: Buffer.from(JSON.stringify(data)),
      InvocationType: 'RequestResponse'
    });
    
    // Invoke the Lambda function
    const response = await lambdaClient.send(command);
    
    // Parse the response
    const responsePayload = new TextDecoder().decode(response.Payload);
    const parsedResponse = JSON.parse(responsePayload);
    
    console.log('CDK Lambda response:', parsedResponse);
    
    if (parsedResponse.statusCode === 200) {
      const body = JSON.parse(parsedResponse.body);
      return {
        success: true,
        message: body.message || 'Feedback submitted successfully',
        id: body.id || `feedback_${Date.now()}`
      };
    } else {
      throw new Error(parsedResponse.body || 'Error submitting feedback');
    }
  } catch (error) {
    console.error('Error submitting feedback to CDK Lambda:', error);
    
    // Format the error response
    const errorResponse: FeedbackResponse = {
      success: false,
      message: error instanceof Error ? error.message : 'An error occurred while submitting feedback',
      error: 'UNKNOWN_ERROR'
    };
    
    throw errorResponse;
  }
};
